import * as tslib_1 from "tslib";
import { AbreCuentasService } from '../abre-cuentas/abre-cuentas.service';
import { BitacoraService } from '../bitacora/bitacora.service';
import { CaptureService } from '../capture/capture.service';
import { CopyService } from '../copies/copy.service';
import { NavigationService } from '../navigation/navigation-onboarding.service';
import { ProductLoaderService } from '../product-loader/product-loader.service';
import * as i0 from "@angular/core";
import * as i1 from "../product-loader/product-loader.service";
import * as i2 from "../copies/copy.service";
import * as i3 from "../capture/capture.service";
import * as i4 from "../navigation/navigation-onboarding.service";
import * as i5 from "../abre-cuentas/abre-cuentas.service";
import * as i6 from "../bitacora/bitacora.service";
var IncomesService = /** @class */ (function () {
    function IncomesService(productLoaderService, copyService, captureService, navigationService, abreCuentasService, bitacoraService) {
        this.productLoaderService = productLoaderService;
        this.copyService = copyService;
        this.captureService = captureService;
        this.navigationService = navigationService;
        this.abreCuentasService = abreCuentasService;
        this.bitacoraService = bitacoraService;
    }
    IncomesService.prototype.callIncomes = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.captureService.performIncomes().then(function (res) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            return tslib_1.__generator(this, function (_a) {
                                if (res !== '200') {
                                    this.navigationService.navigateToGeneralInformation('500');
                                    return [2 /*return*/];
                                }
                                // this.productLoaderService.hide();
                                return [2 /*return*/, '200'];
                            });
                        }); }).catch(function () { return _this.navigationService.navigateToGeneralInformation('500'); })];
                    case 1: 
                    // this.productLoaderService.show(this.copyService.copies.show_load_pco);
                    return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    IncomesService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function IncomesService_Factory() { return new IncomesService(i0.ɵɵinject(i1.ProductLoaderService), i0.ɵɵinject(i2.CopyService), i0.ɵɵinject(i3.CaptureService), i0.ɵɵinject(i4.NavigationService), i0.ɵɵinject(i5.AbreCuentasService), i0.ɵɵinject(i6.BitacoraService)); }, token: IncomesService, providedIn: "root" });
    return IncomesService;
}());
export { IncomesService };
